import {trigger, state, style, transition, animate} from '@angular/animations';
import {
  Component, OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import {FilterContractDigitizationBusinessComponent} from '../filter-contract-digitization/filter-contract-digitization-business.component';
import {MatDialog, MatSort, MatTableDataSource, Sort} from '@angular/material';
import {ToastrService} from 'ngx-toastr';
import {Message} from 'src/app/core/class/message';
import {CommonService} from 'src/app/core/services/common.service';
import {BaseComponent} from 'src/app/shared/components/base/base.component';
import {DigitalContract} from '../filter-contract-digitization/filter-contract-digitization-business.component';
import { format } from 'date-fns';
import {DigitalContractService} from '../../../../../../../core/services/digital-contract.service';
import {WarningComponent} from '../../../../../../../shared/components/warning/warning.component';
import {ErrorCode} from '../../../../../../../core/constants/error-code';
import {Router} from '@angular/router';
import {NotEnoughAlertComponent} from 'src/app/shared/components/not-enough-alert/not-enough-alert.component';
import {FeatureGroup} from 'src/app/core/constants/permission';
import {SelectionModel} from '@angular/cdk/collections';
import {MultiDownloadService} from '../../../../../../../core/services/multi-download.service';
import {EnumDownloadMenuName} from '../../../../../../../core/constants/common';
import {merge, Subscription} from "rxjs";
import {SCREEN_SIZE} from "../../../../../../../core/constants/screen-size";
import {tap} from "rxjs/operators";
import {ResponsiveService} from "../../../../../../../core/services/responsive.service";

@Component({
  selector: 'app-list-contract-business',
  templateUrl: './list-contract-business.component.html',
  styleUrls: ['./list-contract-business.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('void', style({height: '0px', minHeight: '0', visibility: 'hidden'})),
      state('*', style({height: '*', visibility: 'visible'})),
      transition('void <=> *', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ListContractDigitizationBusinessComponent extends BaseComponent implements OnInit, OnDestroy {
  selection = new SelectionModel<string>(true, []);
  displayedColumns: string[] = [];

  columnDefinitions = [
    {def: 'select', showXS: true, showSM: true, showMD: true,showMobile: true},
    {def: 'stt', showXS: true, showSM: true, showMD: true, showMobile: true},
    {def: 'name', showXS: true, showSM: true, showMD: true,showMobile: true},
    {def: 'parent', showXS: false, showSM: false, showMD: false, showMobile: false},
    {def: 'serviceTypeName', showXS: false, showSM: false, showMD: false, showMobile: false},
    {def: 'memoryStorage', showXS: false, showSM: false, showMD: false, showMobile: false},
    {def: 'effectiveDate', showXS: false, showSM: false, showMD: false, showMobile: false},
    {def: 'expiredDate', showXS: false, showSM: false, showMD: false, showMobile: false},
    {def: 'createdBy', showXS: false, showSM: false, showMD: false, showMobile: false},
    {def: 'status', showXS: false, showSM: false, showMD: false, showMobile: false},
    {def: 'action', showXS: true, showSM: true, showMD: true,showMobile: true}
  ];

  paginate: Paginate;

  dataSource: MatTableDataSource<DigitalContract>;

  sorts: object;

  @ViewChild(MatSort, {static: true}) sort: MatSort;

  @ViewChild('searchComponent', {static: false}) searchComponent: FilterContractDigitizationBusinessComponent;

  reloadFilter: boolean;

  featureStatus: boolean;
  userType: number;
  statusBackup: boolean;


  contractDigitalFilter = {
    capacityContractsActive: 0,
    capacityContractsInactive: 0,
    totalContractsActive: 0,
    totalContractsInactive: 0
  };
  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;

  pageIndex: {
    currentPage: number,
    pageSize: number
  };

  constructor(
    private dialog: MatDialog,
    public commonService: CommonService,
    public message: Message,
    private toast: ToastrService,
    private router: Router,
    private digitalContractService: DigitalContractService,
    private downloadService: MultiDownloadService,
    private responsiveService: ResponsiveService,
  ) {
    super(commonService, message);
    this.paginate = {
      currentPage: 0,
      pageSize: 10,
      totalRow: 0,
      totalPage: 0,
      totalPageArray: [],
      no: []
    };
  }

  ngOnInit() {
    this.userType = JSON.parse(localStorage.getItem('userType'));
    const digitalFeature = JSON.parse(localStorage.getItem('featureStatus'));
    digitalFeature.map(item => {
      if (item.permission === FeatureGroup.DIGITAL_CONTRACT) {
        this.featureStatus = item.status;
        this.statusBackup = item.statusBackup;
      }
    });
    this.digitalContractService.checkBackup().subscribe(res => {
      if (res.message === 'OK') {
        this.statusBackup = false;
      } else {
        this.statusBackup = true;
      }
    });
    this.columnDefinitions.forEach(item => {
      this.displayedColumns.push(item.def);
    });
  }

  ngOnDestroy() {
    this.downloadService.clearData();
  }

  getDataTable($event: any) {
    if ($event === null) {
      // filter bắt đầu load: xóa dữ liệu cũ để footer skeleton hiển thị thay thế
      this.dataSource = new MatTableDataSource<DigitalContract>([]);
      return;
    }
    const dataSource = $event.pageData.content;
    if (dataSource.length === 0 && $event.pageData.total > 0) {
      this.paginate.currentPage = 0;
      return;
    }
    let formatWay = 'DD/MM/YYYY';
    dataSource.map(item => {
      item.effectiveDate = item.effectiveDate ? format(format(item.effectiveDate, 'MMM DD, YYYY HH:mm:ss A'), formatWay) : '';
      item.expireDate = item.expireDate ? format(format(item.expireDate, 'MMM DD, YYYY HH:mm:ss A'), formatWay) : '';
    });

    this.dataSource = new MatTableDataSource<DigitalContract>(dataSource);
    this.contractDigitalFilter = $event.contractDigitalFilter;
    this.pageIndex = {
      pageSize: $event.pageData.pageable.size,
      currentPage: $event.pageData.pageable.page
    };
    this.paginate = {
      pageSize: $event.pageData.pageable.size,
      currentPage: $event.pageData.pageable.page,
      totalRow: $event.pageData.total,
      totalPage: Math.ceil($event.pageData.total / $event.pageData.pageable.size),
      totalPageArray: this.counter(Math.ceil($event.pageData.total / $event.pageData.pageable.size), 1),
      no: this.counter($event.pageData.pageable.size, $event.pageData.pageable.page * $event.pageData.pageable.size + 1)
    };
  }
  getDisplayedColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.showMobile)
        .map(cd => cd.def);
    } else {
      this.displayedColumns = this.columnDefinitions.map(cd => cd.def);
    }
  }

  counter(index: number, from: number): any {
    return new Array(index).fill(0).map((x, i) => i + from);
  }
  ngAfterViewInit(page: number = 0) {

    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
          this.getDisplayedColumns();
        }
      }
    );
  }
  onChangePage(e: any) {
    this.paginate.currentPage = e.page ? e.page : 0;
    this.paginate.pageSize = e.pageSize;
  }

  onChangeSort(e: Sort) {
    this.sorts = null;
    if (e.direction === '') {
      return;
    } else if (e.active === 'name') {
      this.sorts = {code: e.direction.toUpperCase()};
    } else {
      this.sorts = {[e.active]: e.direction.toUpperCase()};
    }
  }

  convertCapacity(totalCapacity: number) {
    const capacity = totalCapacity / 1024 / 1024 / 1024;
    if (capacity >= 0.1) {
      return (capacity.toFixed(3)) + 'GB';
    } else {
      return ((totalCapacity / 1024 / 1024).toFixed(3)) + 'MB';
    }
  }

  actionInContract(action: string, id?: string) {
    switch (action) {
      case 'create':
        this.digitalContractService.checkBackup().subscribe(res => {
          if (res.message === 'OK') {
            this.statusBackup = false;
            this.router.navigateByUrl(`/home-enterprise/digital-business/${action}`);
          } else {
            this.statusBackup = true;
            this.toast.error(res.message);
          }
        });
        break;
      case 'update':
        this.digitalContractService.checkBackup().subscribe(res => {
          if (res.message === 'OK') {
            this.statusBackup = false;
            this.router.navigateByUrl(`/home-enterprise/digital-business/${id.replace(/=/g, '')}/${action}`);
          } else {
            this.statusBackup = true;
            this.toast.error(res.message);
          }
        });
        break;
      case 'view':
        this.router.navigateByUrl(`/home-enterprise/digital-business/${id.replace(/=/g, '')}/${action}`);
        break;
    }
  }

  downloadContract(contract) {
    if (contract.id) {
      this.digitalContractService.downloadContract(contract.id).subscribe(res => {
        if (res.type === 'application/json') {
          this.digitalContractService.downloadContractFail(contract.id).subscribe(error => {
            if (error) {
              this.toast.error(error.message);
            }
            return;
          });
        } else if (res) {
          if (window.top.navigator.msSaveOrOpenBlob) {
            // Store Blob in IE
            window.top.navigator.msSaveOrOpenBlob(res, contract.name + '.zip');
          } else {
            // Store Blob in others
            const tA = document.body.appendChild(document.createElement('a'));
            tA.href = window.URL.createObjectURL(res);
            tA.download = contract.code + ' - ' + contract.name + '.zip';
            tA.style.display = 'none';
            tA.click();
            tA.parentNode.removeChild(tA);
          }
        }

      });
    }
  }

  multiDownload() {
    this.downloadService.setData({
      contractIds: this.selection.selected,
      menuContract: EnumDownloadMenuName.LIST_CONTRACT_BUSINESS,
      isDigital: true,
    });
  }


  activeContract(contract) {
    this.digitalContractService.activeContract(contract.id).subscribe(res => {
      if (res && res.success) {
        this.digitalContractService.reloadFilter.next(true);
        this.toast.success(this.message.getMessage('messages.active_contract_success'));
      } else {
        this.reloadFilter = false;
        if (res && res.code === ErrorCode.CreateUpdateDigitalContract6) {
          const dialogConfirm = this.dialog.open(NotEnoughAlertComponent, {
            width: '30%'
          });
          this.reloadFilter = false;
        } else {
          this.toast.error(res.message);
        }
      }
      this.digitalContractService.reloadFilter.next(false);
    });
  }

  deleteContract(contract: DigitalContract) {
    const dialogConfirm = this.dialog.open(WarningComponent, {
      data: this.commonService.format(this.message.getMessage('messages.delete_contract'), contract.code + ' - ' + contract.name),
      width: '40%'
    });
    dialogConfirm.afterClosed().subscribe(ref => {
      if (ref) {
        this.digitalContractService.deleteContract(contract.id).subscribe(res => {
          if (res && res.success) {
            if ((this.paginate.totalRow - 1) % this.paginate.pageSize === 0 && this.paginate.currentPage > 0) {
              this.paginate.currentPage -= 1;
            }
            this.reloadFilter = true;
            this.toast.success(this.message.getMessage('messages.delete_success'));
          } else {
            this.toast.error(res.message);
            this.reloadFilter = false;
          }
        });
      }
      this.reloadFilter = false;
    });
  }

  isAllSelected() {
    const selectedArr = this.selection.selected;
    const dataSourceIds = this.dataSource.data.map(d => d.id);
    const intersectionArr = dataSourceIds.filter(e => selectedArr.includes(e));
    return intersectionArr.length === dataSourceIds.length;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    const dataSourceIds = this.dataSource.data.map(ds => ds.id);
    this.isAllSelected() ?
      this.selection.deselect(...dataSourceIds) :
      this.selection.select(...dataSourceIds);
  }
}

export class Paginate {
  currentPage: number;
  pageSize: number;
  totalRow: number;
  totalPage: number;
  totalPageArray: [];
  no: [];
}
